/**
 * Be Awara Wishlist Manager v2
 * Handles all wishlist buttons across the site:
 *   - .ba-wish        (collection cards) → is-wished
 *   - .ba-ph-wl       (PDP mobile bar)  → is-saved
 *   - .ba-info-wl     (PDP info section) → is-saved
 * Storage: localStorage, customer-aware, migrates legacy ba_wl key
 */
(function () {
  'use strict';

  class BaWishlistManager {
    constructor() {
      var cid = window.baCustomer && window.baCustomer.id;
      this._guestKey = 'ba_wish_guest';
      this._key = cid ? 'ba_wish_' + cid : this._guestKey;
      this._migrateOldKey();
      if (cid) this._mergeGuest();
      this._load();
    }

    // Migrate legacy PDP key (ba_wl) to new key
    _migrateOldKey() {
      try {
        var old = JSON.parse(localStorage.getItem('ba_wl') || '[]');
        if (old.length) {
          var cur = JSON.parse(localStorage.getItem(this._key) || '[]');
          var merged = Array.from(new Set(cur.concat(old)));
          localStorage.setItem(this._key, JSON.stringify(merged));
          localStorage.removeItem('ba_wl');
        }
      } catch (_) {}
    }

    // Merge guest wishlist into customer wishlist on login
    _mergeGuest() {
      try {
        var guest = JSON.parse(localStorage.getItem(this._guestKey) || '[]');
        if (guest.length) {
          var cur = JSON.parse(localStorage.getItem(this._key) || '[]');
          var merged = Array.from(new Set(cur.concat(guest)));
          localStorage.setItem(this._key, JSON.stringify(merged));
          localStorage.removeItem(this._guestKey);
        }
      } catch (_) {}
    }

    _load() {
      try { this._items = JSON.parse(localStorage.getItem(this._key) || '[]'); }
      catch (_) { this._items = []; }
    }

    _save() {
      try { localStorage.setItem(this._key, JSON.stringify(this._items)); } catch (_) {}
      window.dispatchEvent(new CustomEvent('ba:wish:change', { detail: { items: this._items.slice() } }));
    }

    add(handle)    { if (!this.has(handle)) { this._items.push(handle); this._save(); } }
    remove(handle) { this._items = this._items.filter(function(h){ return h !== handle; }); this._save(); }
    toggle(handle) { this.has(handle) ? this.remove(handle) : this.add(handle); return this.has(handle); }
    has(handle)    { return this._items.indexOf(handle) !== -1; }
    getAll()       { return this._items.slice(); }
    count()        { return this._items.length; }
    clear()        { this._items = []; this._save(); }

    getShareUrl() {
      var base = window.location.origin + '/pages/wishlist';
      return this._items.length ? base + '?items=' + this._items.join(',') : base;
    }
  }

  // ── Global instance ──────────────────────────────────────────────────────
  window.baWishlist = new BaWishlistManager();

  // ── Which active class does this button use? ─────────────────────────────
  function activeClass(btn) {
    return (btn.classList.contains('ba-ph-wl') || btn.classList.contains('ba-info-wl'))
      ? 'is-saved' : 'is-wished';
  }

  // ── Global toggle — called by onclick="baWish(this)" ────────────────────
  window.baWish = function (btn) {
    var handle = btn.dataset.handle;
    if (!handle) return;
    var wished = window.baWishlist.toggle(handle);
    // Update all buttons for this product on the page
    document.querySelectorAll('[data-handle="' + handle + '"]').forEach(function (b) {
      b.classList.toggle(activeClass(b), wished);
    });
  };

  // ── Sync every heart button on the page ─────────────────────────────────
  function syncButtons() {
    var items = window.baWishlist.getAll();
    // Collection / card buttons (.ba-wish)
    document.querySelectorAll('.ba-wish[data-handle]').forEach(function (btn) {
      btn.classList.toggle('is-wished', items.indexOf(btn.dataset.handle) !== -1);
    });
    // PDP buttons (.ba-ph-wl, .ba-info-wl)
    document.querySelectorAll('.ba-ph-wl[data-handle], .ba-info-wl[data-handle]').forEach(function (btn) {
      btn.classList.toggle('is-saved', items.indexOf(btn.dataset.handle) !== -1);
    });
  }

  document.addEventListener('DOMContentLoaded', syncButtons);
  window.addEventListener('ba:wish:change', syncButtons);
})();
